<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
	.tag-btn {
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>店铺管理</el-breadcrumb-item>
			<el-breadcrumb-item>店铺列表</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center;">
				<div>搜索：</div>
				<el-input size="mini" placeholder="模糊搜索 店铺名 / 账号 / SID" v-model="searchForm.keyword" style="margin-right: 10px; width:200px;"></el-input>
				<div>&nbsp;&nbsp;上级代理：</div>
				<el-input size="mini" placeholder="模糊搜索 店铺名 / 账号 / SID" v-model="searchForm.pkeyword" style="margin-right: 10px; width:200px;"></el-input>
				<el-button size="mini" type="primary" @click="searchFunc()">搜索</el-button>
				<el-button size="mini" type="warning" @click="currentPage=1;reset();getData()">重置</el-button>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="sid" label="店铺ID" align="center" width="100"></el-table-column>
				
				
				
				<el-table-column prop="username" label="账号" align="center" width="180">
					<template slot-scope="scope">
						<span>{{scope.row.username}}</span>
						<span style="color: #3399ff; margin-left: 10px;">{{scope.row.remarks}}</span>
						<i style="color: green; margin-left: 10px;" class="el-icon-edit" @click="editRemark(scope)"></i>
					</template>
				</el-table-column>
				<el-table-column prop="shop_name" label="店铺名称" align="center" width="140">
				</el-table-column>
				<el-table-column prop="realname" label="店主姓名" align="center" width="120">
				</el-table-column>
				<el-table-column prop="shop_name" label="推荐店主" align="center" width="200">
					<template slot-scope="scope">
						{{scope.row.pshop_name}}({{scope.row.pusername}})
					</template>
				</el-table-column>
				<el-table-column prop="userCount" label="用户数" align="center" width="100">
				</el-table-column>
				<el-table-column prop="balance" label="服务费余额" align="center" width="100">
				</el-table-column>
				
				<el-table-column prop="rates" label="服务点位" align="center" width="100">
				</el-table-column>
				
				<el-table-column prop="shop_status" label="店铺状态" align="center" width="100">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.auth_status == 0" size="mini">休息中</el-tag>
						<el-tag type="danger" v-if="scope.row.shop_status == 1" size="mini">营业中</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="status" label="账号状态" align="center" width="100">
					<template slot-scope="scope">
						<el-tag type="info" v-if="scope.row.status == 0" size="mini">待审核</el-tag>
						<el-tag v-if="scope.row.status == 1" size="mini">正常</el-tag>
						<el-tag type="danger" v-if="scope.row.status == 99" size="mini">封禁</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="check_time" label="启用时间" width="160" align="center">
				</el-table-column>
				<el-table-column prop="last_login_time" label="最后登录时间" width="160" align="center">
				</el-table-column>
				<el-table-column prop="last_login_ip" label="最后登录IP" width="200" align="center">
				</el-table-column>
				<el-table-column prop="status" label="操作" fixed="right" width="350" align="center">
					<template slot-scope="scope">
						<el-tag class='tag-btn' type="warning" style="margin-right: 10px;" size="mini" @click="chatTo(scope)">联系店主</el-tag>
						<el-tag class='tag-btn' type="success" style="margin-right: 10px;" size="mini"  @click="payManager(scope)">支付管理</el-tag>
						<el-tag class='tag-btn' type="primary" style="margin-right: 10px;" size="mini"  @click="walletManager(scope)">钱包管理</el-tag>
						<el-tag class='tag-btn' type="danger" style="margin-right: 10px;" size="mini"  @click="shopManager(scope)">店铺管理</el-tag>
					</template>
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[14, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
		<el-dialog top="30px" :title="walletTitle" :visible.sync="payShow" v-if="payShow" width="1200px" :before-close="handleClose">
			<payManager :sid="actionSid"></payManager>
		</el-dialog>
		
		<el-dialog top="30px" :title="walletTitle" :visible.sync="walletShow" v-if="walletShow" width="900px" :before-close="handleClose">
			<wallet :sid="actionSid"></wallet>
		</el-dialog>
		
		<el-dialog :title="walletTitle" :visible.sync="managerShopShow" v-if="managerShopShow" width="900px" :before-close="handleClose1">
			<shopManager :sid="actionSid"></shopManager>
		</el-dialog>
	</div> 
</template>

<script>
	import payManager from './action/payManager.vue';
	import wallet from './action/wallet.vue';
	import shopManager from './action/shopManager.vue';
	export default {
		components:{
			wallet, shopManager, payManager
		},
		computed:{
		},
		data(){
			return {
				payShow:false,
				managerShopShow:false,
				actionSid:0,
				walletTitle:'',
				walletShow:false,
				
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:14,
				searchForm:{
					pkeyword:'',
					keyword:'',
				},
			}
		},
		created() {
			this.getData();
		},
		methods:{
			chatTo(scope){
				console.log(scope.row.sid);
				let that = this;
				that.loading = true;
				that.$api.post("/Shop/chatTo", {sid: scope.row.sid}).then(res=>{
					that.loading = false;
					that.$message({'title':'操作成功'});
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleClose1(){
				this.managerShopShow = false;
			},
			handleClose(){
				this.managerShopShow = false;
				this.walletShow = false;
			},
			shopManager(scope){
				this.managerShopShow = true;
				this.actionSid = scope.row.sid;
				this.walletTitle = '店铺：' +  scope.row.shop_name + ' | 账号：' + scope.row.username + ' | SID：' + scope.row.sid
			},
			walletManager(scope){
				this.actionSid = scope.row.sid;
				this.walletShow = true;
				this.walletTitle = '店铺：' +  scope.row.shop_name + ' | 账号：' + scope.row.username + ' | SID：' + scope.row.sid
			},
			payManager(scope){
				this.actionSid = scope.row.sid;
				this.payShow = true;
				this.walletTitle = '店铺：' +  scope.row.shop_name + ' | 账号：' + scope.row.username + ' | SID：' + scope.row.sid
			},
			lotteryManager(scope){
				
			},
			searchFunc(){
				this.currentPage = 1;
				this.getData();
			},
			reset(){
				this.searchForm = {
					pkeyword:'',
					keyword:'',
					is_agent:'',
					online:'',
					endTime:'',
					pid:'',
				};
			},
			calcDays(_time){
				if(_time == 0) return '-';
				let _nowtime = new Date().getTime();
				let _subTime =  _time * 1000 - _nowtime;
				let _days = _subTime / 1000 / 60 / 60 / 24;
				return _days.toFixed(2) + '天';
			},
			handleClose(){
				this.pushShow = false;
				this.walletShow = false;
				this.editShow = false;
				this.payShow = false;
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/Shop/getShopList", {page:this.currentPage, limit:this.limit, ...this.searchForm}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			}
		}
	}
</script>

